(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/constants.js');
"use strict";



const ROUTES = {
  LOBBY: '/',
  GAME_INFO: '/info/:gameUrl',
  PLAY: '/spela/:gameUrl',
  DEMO_PLAY: '/provspela/:gameUrl',
  BET_DETAIL: '/mina-spel/:wagerId'
};
setGlobal('svs.eInstant.constants', {
  ROUTES
});

 })(window);